import React, {
  PropsWithChildren,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react'

import { faker } from '@faker-js/faker/locale/en'

import * as S from './styles'
import { Text, ImageSlideContainer } from '@/components'
import { useSwipe } from '@/hooks/useSwipe'
import { HeroProps } from '@/service/api/servicesPage'

export type ServicesHeroContainerProps = PropsWithChildren<{
  data: HeroProps
}>

export const ServicesHeroContainer: React.FC<ServicesHeroContainerProps> = ({
  data,
}) => {
  const timerRef = useRef<NodeJS.Timeout>()
  const swipeContainerRef = useRef<HTMLDivElement>(null)

  const [currentCase, setCurrentCases] = useState(0)

  const goNext = useCallback(() => {
    if (currentCase + 1 === data.cases.length) {
      setCurrentCases(0)
      return
    }

    setCurrentCases(currentCase + 1)
  }, [currentCase, data.cases.length])

  const goPrev = useCallback(() => {
    if (currentCase === 0) {
      setCurrentCases(data.cases.length - 1)
      return
    }

    setCurrentCases(currentCase - 1)
  }, [currentCase, data.cases.length])

  useSwipe({
    elementRef: swipeContainerRef,
    leftSwipe: () => goNext(),
    rightSwipe: () => goPrev(),
  })

  useEffect(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
    }
    timerRef.current = setTimeout(() => {
      goNext()
    }, 6000)

    return () => {
      clearTimeout(timerRef.current)
    }
  }, [currentCase, data.cases.length, goNext])

  return (
    <S.Container padding="0">
      <S.TextContainer>
        <Text size="h3" color="primary" className="title">
          {data.title}
        </Text>
        <Text size="b1" className="description">
          {data.description}
        </Text>
      </S.TextContainer>

      <S.CaseContainer ref={swipeContainerRef}>
        <S.SlideContainer>
          {data.cases.length && (
            <ImageSlideContainer
              content={data.cases}
              currentIndex={currentCase}
            />
          )}
        </S.SlideContainer>

        <S.CasePaginationContainer>
          <S.PaginationDotsContainer>
            {data.cases.length &&
              data.cases.map((el, idx) => (
                <S.PaginationDot
                  selected={currentCase === idx}
                  key={faker.datatype.uuid()}
                  onClick={() => {
                    clearTimeout(timerRef.current)
                    setCurrentCases(idx)
                  }}
                />
              ))}
          </S.PaginationDotsContainer>
          <Text size="b2">{data.cases[currentCase].title}</Text>
        </S.CasePaginationContainer>
      </S.CaseContainer>
    </S.Container>
  )
}
